export default __webpack_public_path__ + "static/media/item-1.333963e7.png";